import React from "react";
import { MenuItem, TextField } from "@material-ui/core";
import { useDeviceStatusManager } from "./DeviceStatusManager";

export default function({fullWidth}){
    const {type, setType} = useDeviceStatusManager();

    return <TextField
            fullWidth={fullWidth}
            variant="outlined"
            label="View"
            onChange={e => setType(e.target.value)}
            value={type}
            size="small"
            select
        >
            <MenuItem value="info">Info Log</MenuItem>
            <MenuItem value="status">Status</MenuItem>
    </TextField>
}